function filter_start_string(search,field){
    var s_length = search.length;
    var field_length = field.length;
    if(field_length < s_length){
        return false;
    }
    var crop_id = field.substring(0,s_length);
    return crop_id == search;
}

function initcapsentece(sentence){
    var new_sent = "";
    sentence.split(" ").forEach(function(word){
        new_sent += initcapword(word)+" ";
    });
    return new_sent.trim();
}
function initcapword(word) {
    return word[0].toUpperCase() + word.slice(1).toLowerCase();
}
function sendHotetec(payload, bookingUrl) {
    const isHotetecProperty = true,
        endpoint = bookingUrl;


    if (isHotetecProperty) {
        const formData = [{
                key: "hotelCode",
                value: payload.hotelCode
            },
            {
                key: "dateFrom",
                value: payload.dateIn.day + '/' + payload.dateIn.month + '/' + payload.dateIn.year
            },
            {
                key: "dateTo",
                value: payload.dateOut.day + '/' + payload.dateOut.month + '/' + payload.dateOut.year
            },
            {
                key: "distribution[0].adults",
                value: payload.adults
            },
            {
                key: "distribution[0].id",
                value: "1"
            },
            {
                key: "vendorCode",
                value: "BDMD"
            },
            {
                key: "refresh",
                value: true
            },
        ]


        for (let childIndex = 0; childIndex < payload.numberOfChildren; childIndex++) {
            const childAge = payload.age[childIndex];

            formData.push({
                key: "distribution[0].childAge",
                value: childAge
            })
        }

        const tempForm = document.createElement("form");
        tempForm.setAttribute("method", "GET");
        tempForm.setAttribute("target", "_blank"); // You can remove line + set your Network log (in the developer console) to preserve log to debug the payload  
        tempForm.setAttribute("action", endpoint);

        for (let index = 0; index < formData.length; index++) {
            const data = formData[index];
            const input = document.createElement("input");
            input.setAttribute("type", "hidden");
            input.setAttribute("name", data.key);
            input.setAttribute("value", data.value);

            tempForm.appendChild(input);
        }

        document.body.appendChild(tempForm);
        tempForm.submit();
        tempForm.remove();
    }
}

function sendHotetec2(payload, bookingUrl) {
    
    let childAge = '';
    for (let childIndex = 0; childIndex < payload.numberOfChildren ; childIndex++) {
        childAge += '#chd-'+payload.age[childIndex];
    }
    const endpoint = bookingUrl,
        formData = [{
            key: "hotelCode",
            value: payload.hotelCode
        },
        {
            key: "dateFrom",
            value: payload.dateIn.day + '/' + payload.dateIn.month + '/' + payload.dateIn.year
        },
        {
            key: "dateTo",
            value: payload.dateOut.day + '/' + payload.dateOut.month + '/' + payload.dateOut.year
        },
        {
            key: "distribution",
            value: "ad-"+payload.adults+childAge
        },
        {
            key: "currency",
            value: "USD"
        },
        {
            key: "language",
            value: payload.language
        },
        {
            key: "bookingEngine",
            value: payload.hotetec_code
        }
    ]

    // for (let childIndex = 0; childIndex < payload.numberOfChildren; childIndex++) {
    //     const childAge = payload.age[childIndex];

    //     formData.push({
    //         key: "distribution[0].childAge",
    //         value: childAge
    //     })
    // }

    const tempForm = document.createElement("form");
    tempForm.setAttribute("method", "GET");
    tempForm.setAttribute("target", "_blank");
    tempForm.setAttribute("action", endpoint);

    for (let index = 0; index < formData.length; index++) {
        const data = formData[index];
        const input = document.createElement("input");
        input.setAttribute("type", "hidden");
        input.setAttribute("name", data.key);
        input.setAttribute("value", data.value);

        tempForm.appendChild(input);
    }

    document.body.appendChild(tempForm);
 
    tempForm.submit();
    tempForm.remove();
}
function sendReservHotel(payload, bookingUrl) {
    const endpoint = bookingUrl,
        formData = [{
            key: "hotel",
            value: payload.hotelCode
        },
        {
            key: "adate",
            value: payload.dateIn.day + '-' + payload.dateIn.month + '-' + payload.dateIn.year
        },
        {
            key: "ddate",
            value: payload.dateOut.day + '-' + payload.dateOut.month + '-' + payload.dateOut.year
        },
        {
            key: "adults",
            value: payload.adults
        },
        {
            key: "child",
            value: payload.numberOfChildren
        },
        {
            key: "rooms",
            value: payload.rooms
        },
        {
            key: "showhotel",
            value: (payload.airport == "") ? "Y" : "N"
        },
        {
            key: "airport",
            value: payload.airport
        },
        {
            key: "date_format",
            value: "dd-mm-yyyy"
        },
        {
            key: "lang",
            value: (payload.language == 'es') ? '2' : '1'
        }
    ]
     
    for (let childIndex = 0; childIndex < payload.numberOfChildren; childIndex++) {
        const childAge = payload.age[childIndex];

        formData.push({
            key: "childages",
            value: childAge
        })
    }

    // var childagesParam = "";
    // for (let childIndex = 0; childIndex < payload.numberOfChildren; childIndex++) {
    //     if(childagesParam != "") childagesParam += "|";
    //     childagesParam += payload.age[childIndex];
    // }
    // formData.push({
    //     key: "childages",
    //     value: childagesParam
    // });

    const tempForm = document.createElement("form");
    tempForm.setAttribute("method", "GET");
    tempForm.setAttribute("target", "_blank");
    tempForm.setAttribute("action", endpoint);

    for (let index = 0; index < formData.length; index++) {
        const data = formData[index];
        const input = document.createElement("input");
        input.setAttribute("type", "hidden");
        input.setAttribute("name", data.key);
        input.setAttribute("value", data.value);

        tempForm.appendChild(input);
    }

    document.body.appendChild(tempForm);

    tempForm.submit();
    tempForm.remove();
}
function sendSynxis(payload, bookingUrl) {
    const endpoint = bookingUrl,
        formData = [{
            key: "hotel",
            value: payload.hotelCode
        },
        {
            key: "arrive",
            value: payload.dateIn.year + '-' + payload.dateIn.month + '-' + payload.dateIn.day
        },
        {
            key: "depart",
            value: payload.dateOut.year + '-' + payload.dateOut.month + '-' + payload.dateOut.day
        },
        {
            key: "adult",
            value: payload.adults
        },
        {
            key: "child",
            value: payload.numberOfChildren
        },
        {
            key: "rooms",
            value: payload.rooms
        },
        {
            key: "locale",
            value: (payload.language == 'es') ? 'es-MX' : 'en-US'
        }
    ]

    var childagesParam = "";
    for (let childIndex = 0; childIndex < payload.numberOfChildren; childIndex++) {
        if(childagesParam != "") childagesParam += "|";
        childagesParam += payload.age[childIndex];
    }

    formData.push({
        key: "childages",
        value: childagesParam
    });

    const tempForm = document.createElement("form");
    tempForm.setAttribute("method", "GET");
    tempForm.setAttribute("target", "_blank");
    tempForm.setAttribute("action", endpoint);

    for (let index = 0; index < formData.length; index++) {
        const data = formData[index];
        const input = document.createElement("input");
        input.setAttribute("type", "hidden");
        input.setAttribute("name", data.key);
        input.setAttribute("value", data.value);

        tempForm.appendChild(input);
    }

    document.body.appendChild(tempForm);

    tempForm.submit();
    tempForm.remove();
}
    
$(document).ready(function() {

    $('.booking-v2 form').submit(function(e) {
        e.preventDefault();

        let $this = $(this);
        const idForm = this.id;
        const form = e.target;


        var booking = $(`#${idForm} input[name='booking']`).val(),
            hotel_code = $(`#${idForm} input[name='hotel']`).val(),
            checkin = $(`#${idForm} input[name='arrive']`).val().split('/'),
            checkout = $(`#${idForm} input[name='depart']`).val().split('/'),
            numberOfChildren = $(`#${idForm} input[name='child']`).val(),
            adults = $(`#${idForm} input[name='adult']`).val(),
            //age = (numberOfChildren==0)?[]:$(`#${idForm}  [name='childages']`).val().split('|'),
            age = ((numberOfChildren === 0) ? [] : $(`#${idForm} [name='childages[]']`).map(function() {
                return $(this).val();
            }).get()),
            rooms = $(`#${idForm}  input[name='rooms']`).val(),
            airport = $(`#${idForm}  input[name='airport']`).val(),
            endpoint = $this.attr('action'),
            hotetec_code = $(`#${idForm}  input[name='hotetec_code']`).val();
            
            if(booking == 'Synxis+Reserv') {
                if (hotel_code.includes('|')) {
                    hotel_code = hotel_code.split('|');
                }
                var selected_option = $(".tabs li.active").data("type");
                if(selected_option == 'hotel-only') {
                    hotel_code = hotel_code[0];
                } else {
                    hotel_code = hotel_code[1];    
                    booking = 'reserv';                
                }
            }

        if (booking == undefined)
            booking = 'Synxis';

        var error_message = '';
        //validations
        $(`#${idForm} .properties__label`).removeClass('error');
        if(hotel_code == "") {
            $(`#${idForm} .properties__label`).addClass('error');
            error_message = 'Select a resort';
        }
        if(airport == "" && selected_option == "hotel-air") {
            $(`#${idForm} .new-airport-input`).addClass('error');
            error_message = 'Select an airport from the list';
        }
        if($(`#${idForm} input[name='arrive']`).val() == $(`#${idForm} input[name='depart']`).val()) {
            $(`#${idForm} .dates input[type="text"]`).addClass('error');
            error_message = "Please note, the check-out date must be different from the check-in date";
        }
        if(error_message != '') {
            $(`#${idForm} #errorMessage`).html(error_message);
            $(`#${idForm} #errorMessage`).show();
            return
        } else {
            $(`#${idForm} #errorMessage`).hide();
        }
        
 
        const payload = {
            hotelCode: hotel_code,
            dateIn: {
                day: checkin[1],
                month: checkin[0],
                year: checkin[2],
            },
            dateOut: {
                day: checkout[1],
                month: checkout[0],
                year: checkout[2],
            },
            adults: adults,
            numberOfChildren: numberOfChildren,
            rooms: rooms,
            age: age,
            airport: airport,
            language: langSelected,
            hotetec_code: hotetec_code
        };

        console.log("booking: "+booking.toLowerCase());

        if (booking.toLowerCase() == 'hotetec') {
            sendHotetec2(payload, endpoint);
        } else if(booking.toLowerCase() == 'reserv') { 
            sendReservHotel(payload, endpoint);
        } else {
            sendSynxis(payload, endpoint);
        }


    });

	//Open/close widget
    $('.header__book').click(function(e) {
        e.preventDefault();
        $('.booking-v2.lightbox').toggleClass('open');
        $('.booking-v2-overlay').toggleClass('open');
        $('.hero .booking-v2').fadeOut();
    }); 
    $('.js-open-widget, .booking__close, .booking-v2-overlay').click(function(e) {
        e.preventDefault();
        $('.booking-v2').removeClass('open');
        $('.booking-v2-overlay').removeClass('open');
        $('.hero .booking-v2').fadeIn();
        if($('.properties__select').hasClass('properties__select-open')) {
            $('.properties__select').addClass("hidden");
            $('.properties__select').removeClass("properties__select-open");
        }
    }); 

    $('.js-select-hotel').click(function() {
        var topPosition = document.documentElement.scrollTop;
        var pageHeight = $(window).height() / 2;
        pageHeight = pageHeight / 2;
        if(topPosition < pageHeight) {
            $('.properties__select').removeClass('bw_options_bottom');
            $('.properties__select').addClass('bw_options_top');
        } else {
            $('.properties__select').addClass('bw_options_bottom');
            $('.properties__select').removeClass('bw_options_top');
        }
        $(this).children('.properties__select').toggleClass("hidden");
        $(this).children('.properties__select').toggleClass("properties__select-open");
        $('.booking-v2-overlay').addClass('open');
    })
    
    // to mobile version
    $('#properties1,#properties2').change(function() {
        let form = $(this).closest("form"),
            clientFolder = $(this).find(':selected').data('client'),
            sizeAdults = $(this).find(':selected').data('length_adults'),
            sizeKids = $(this).find(':selected').data('length_kids'),
            hotel_id = $(this).find(':selected').val(), 
            acceptance = $(this).find(':selected').data('resort_acceptance'),
            booking = $(this).find(':selected').data('booking_engine');

        document.querySelectorAll('[name=booking]').forEach(function(element) {
            element.value = booking;
        }); 
        document.querySelectorAll('[name=hotel]').forEach(function(element) {
            element.value = hotel_id;
        });

        let optionSel = $(this).find(':selected').text();

        let endpoint = '';
        let hotetec_be_code = ''; 
        let air_option = false;

        if(booking.includes('Reserv')) {
            air_option = true;
        }
        if(sizeAdults != '') {
            $('*[data-field="adult"]').attr('data-max',sizeAdults);            
        } 
        if(sizeKids != '') {
            $('*[data-field="child"]').attr('data-max',sizeKids);            
        }

        if (acceptance == 'Adults Only') {
            $('.selector__custom.children').hide();
            $('.child-age').addClass("hidden");
            $('.selector__custom.children .decrease').addClass('inactive');
            $('.selector__custom.children .increase').removeClass('inactive');
            $('.selector__custom.children .selector__custom--total').html('00');
            $('input[name=child]').val(0);
            // var childAgeUnits = document.querySelectorAll('.child-age__unit');
            // if (childAgeUnits.length > 2) {
            //     childAgeUnits[1].remove();
            // }
        } else {
            $(form).find('.selector__custom.children').show()
        }

        var currentChildren = parseInt($(form).find('input[name=child]').val());
        var currentAdults = parseInt($(form).find('input[name=adult]').val());
        var $totalGuest = currentAdults+currentChildren;
        $(".fakeguests").val("0"+$totalGuest);

        if (booking == 'HoteTec') {
            
            endpoint = hotetec;

            if (clientFolder === undefined || clientFolder === '') {
                hotetec_be_code = hotetec_code;
            } else {
                if (clientFolder == 'mystique-resorts') {
                    hotetec_be_code = hotetec_code_mystique;
                } else if (clientFolder == 'memories-resort') {
                    hotetec_be_code = hotetec_code_memories;
                } else if (clientFolder == 'starfish-resorts') {
                    hotetec_be_code = hotetec_code_starfish;
                } else {
                    hotetec_be_code = hotetec_code_royalton;
                }
            }
        } else if (booking == 'Reserv') {
            endpoint = "https://www.reservhotel.com/win/owa/ibe5.main";
        } else {
            if (clientFolder === undefined || clientFolder === '') {
                endpoint = synxis;
            } else {
                if (clientFolder == 'mystique-resorts') {
                    endpoint = synxis_mystique;
                } else if (clientFolder == 'planet-hollywood') {
                    endpoint = synxis_planet;
                } else {
                    endpoint = synxis;
                }
            }
        }

        if(air_option) {
            $('.tabs').removeClass("hidden");
            //$('.rooms .selector__custom--action.increase').addClass("inactive");
            $('.booking-v2 .form').addClass("show-tabs");
            $('.tabs li.hotel-only').trigger( "click" );
        } else {
            $('.tabs').addClass("hidden");
            $('.tabs li.hotel-only').trigger( "click" ); 
            //$('.rooms .selector__custom--action.increase').removeClass("inactive");
            $('.booking-v2 .form').removeClass("show-tabs");
        }

        $(form).attr('action', endpoint);
        $('input[name=hotetec_code]').val(hotetec_be_code)

        //reloadSelect($(form).find('select[name="adult"]'), sizeAdults);
        //reloadSelect($(form).find('select[name="child"]'), sizeKids)
        // $('.child-age').hide()
        // $('.childages').val('')
        // children1 = []
        // children2 = []
    });

    // to desktop version
    $('.properties__select li').click(function() {
        let form = $(this).closest("form"),
            clientFolder = $(this).data('client'),
            sizeAdults = $(this).data('length_adults'),
            sizeKids = $(this).data('length_kids'),
            acceptance = $(this).data('resort_acceptance'),
            booking = $(this).data('booking_engine'),
            hotel_id = $(this).data('value'),
            hotel_name = $(this).html();


        if(sizeAdults != '') {
            console.log('adults:'+sizeAdults);
            $('*[data-field="adult"]').attr('data-max',sizeAdults);            
        } 
        if(sizeKids != '') {
            $('*[data-field="child"]').attr('data-max',sizeKids);            
        }

        if (acceptance == 'Adults Only') {
            $('.selector__custom.children').hide();
            $('.child-age').addClass("hidden");
            $('.selector__custom.children .decrease').addClass('inactive');
            $('.selector__custom.children .increase').removeClass('inactive');
            $('.selector__custom.children .selector__custom--total').html('00');
            $('input[name=child]').val(0);
        } else {  
            $('.selector__custom.children').show();
            let age_limit = (booking == 'HoteTec') ? 12 : 17;
            document.querySelectorAll('select[name="childages[]"]').forEach(select => {
                select.innerHTML = '';
                for (let i = 1; i <= age_limit; i++) {
                    let option = document.createElement('option');
                    option.value = i;
                    option.textContent = i;
                    select.appendChild(option);
                }
            });
        }

        var currentChildren = parseInt($(form).find('input[name=child]').val());
        var currentAdults = parseInt($(form).find('input[name=adult]').val());
        var $totalGuest = currentAdults+currentChildren;
        $(".fakeguests").val("0"+$totalGuest);

        $(form).find('.properties__label').addClass('selected');

        document.querySelectorAll('[name=booking]').forEach(function(element) {
            element.value = booking;
        });
        document.querySelectorAll('[name=hotel]').forEach(function(element) {
            element.value = hotel_id;
        });
        document.querySelectorAll('.properties__label p').forEach(function(element) {
            element.textContent = hotel_name;
        });

        let optionSel = $(this).text();
        let endpoint = ''; 
        let hotetec_be_code = ''; 
        let air_option = false;
        $('.bookNow').prop("disabled", false);

        if(booking.includes('Reserv')) {
            air_option = true;
        }
        if (booking == 'HoteTec') {
            endpoint = hotetec;

            if (clientFolder === undefined || clientFolder === '') {
                hotetec_be_code = hotetec_code;
            } else {
                if (clientFolder == 'mystique-resorts') {
                    hotetec_be_code = hotetec_code_mystique;
                } else if (clientFolder == 'memories-resort') {
                    hotetec_be_code = hotetec_code_memories;
                } else if (clientFolder == 'starfish-resorts') {
                    hotetec_be_code = hotetec_code_starfish;
                } else {
                    hotetec_be_code = hotetec_code_royalton;
                }
            }

        } else if (booking == 'Reserv') {
            endpoint = "https://www.reservhotel.com/win/owa/ibe5.main";
        } else {
            if (clientFolder === undefined || clientFolder === '') {
                endpoint = synxis;
            } else {
                if (clientFolder == 'mystique-resorts') {
                    endpoint = synxis_mystique;
                } else if (clientFolder == 'planet-hollywood') {
                    endpoint = synxis_planet;
                } else {
                    endpoint = synxis;
                }
            }
        }

        if(air_option) {
            $('.tabs').removeClass("hidden");
            //$('.tabs li.hotel-air').trigger( "click" );
            //$('.rooms .selector__custom--action.increase').addClass("inactive");
            $('.booking-v2 .form').addClass("show-tabs");
            $('.tabs li.hotel-only').trigger( "click" ); 
        } else {
            $('.tabs').addClass("hidden");
            $('.tabs li.hotel-only').trigger( "click" );
            //$('.rooms .selector__custom--action.increase').removeClass("inactive");
            $('.booking-v2 .form').removeClass("show-tabs");
        }

        $("#booking-form,#booking-form2").attr('action', endpoint);

        $('input[name=hotetec_code]').val(hotetec_be_code)
        
        //reloadSelect($(form).find('select[name="adult"]'), sizeAdults);
        //reloadSelect($(form).find('select[name="child"]'), sizeKids)
        // $('.child-age').hide()
        // $('.childages').val('')
        // children1 = [] 
        // children2 = []
    });

    document.querySelectorAll('.new-airport-input').forEach(input => {
        input.addEventListener('focus', function () {
            //this.value = ''; 
        });
    });   
    
    $('.new-airport-input').autocomplete({
        minLength : 3,
        html : true,
        position : {
           my : "left top+20",
           at : "left bottom"
        },
        source : function(request, response) {
           var search = request.term.toUpperCase();
           var search_result = [];
           $.getJSON(
              "/airports.json", 
              function( data ) {
                 var airports = [];
                 $.each( data.airports, function( key, val ) {
                    airports.push(val);
                 });

                 var search_codes = airports.filter((airport)=>filter_start_string(search,airport.AI_ID));
                 search_codes.forEach(function(airport){
                    if(airport.AI_COUNTRY != "CA") {
                        search_result.push(
                        {
                            "label": initcapsentece(airport.AI_NAME)+", "+airport.AI_STATE+" "+airport.AI_COUNTRY+" ("+airport.AI_ID+")",
                            "value": airport.AI_ID,
                        }
                        );
                    }
                 });

                 var search_start_name = airports.filter(
                    function(airport){
                       if(filter_start_string(search, airport.AI_NAME)){
                          return !(filter_start_string(search,airport.AI_ID));
                       }
                       return false;
                    }
                 );
                 search_start_name.forEach(function(airport){
                    if(airport.AI_COUNTRY != "CA") {
                        search_result.push(
                           {
                              "label": initcapsentece(airport.AI_NAME)+", "+airport.AI_STATE+" "+airport.AI_COUNTRY+" ("+airport.AI_ID+")",
                              "value": airport.AI_ID,
                           }
                        );
                    } 
                 });

                 var search_any_name = airports.filter(
                    function(airport){
                       if(airport.AI_NAME.includes(search)){
                          return !(filter_start_string(search, airport.AI_NAME))
                       }
                       return false;
                    }
                 );
                 search_any_name.forEach(function(airport){
                    if(airport.AI_COUNTRY != "CA") {
                        search_result.push(
                        {
                            "label": initcapsentece(airport.AI_NAME)+" ("+airport.AI_ID+")",
                            "value": airport.AI_ID,
                        }
                        );
                    }
                 });
                 response(search_result);
              }
           );
        },
        open : function() {
           $('.ui-autocomplete').width($(this).outerWidth() + 100);
        },
        select : function(event, ui) {
           event.preventDefault();
           $(".new-airport-input").val(ui.item.label);
           $("input[name=airport]").val(ui.item.value);
           if ($('.selected .ui-state-default').length > 0) {
              $('.selected .ui-state-default').popover('destroy');
           }
        }
     }); 

     $(".fakeguests").focus(function() {
        $(this).parent().addClass("focus");
        $(".promo__selector").hide();
     });
     $(".closeSelector").click(function(e) {
        e.preventDefault();
        $(".field.guests").removeClass("focus");
     });

     $(".tabs li").click(function() {

        $(".tabs li").removeClass("active");
        $(this).addClass("active");
        var booking_type = $(this).parent().siblings("input[name='booking']").val(); 

        var tab_option = $(this).attr("data-type");

        if(tab_option == 'hotel-only') {
            $(".airport-from, .airport-to").hide();
            $(".form").removeClass("hotel-air");
            $(".form").addClass("hotel-only");
            $('.new-airport-input').removeAttr("required");
            //if(booking_type == 'Synxis+Reserv') {
                //$(this).parent().parent("form").attr("action",synxis);
                $(".booking-v2 form").attr("action",synxis);
            //}
        }  else {
            $(".airport-from, .airport-to").show();
            $(".form").addClass("hotel-air");
            $(".form").removeClass("hotel-only");
            $(".new-airport-input").attr("required","required");
            //if(booking_type == 'Synxis+Reserv') {
                //$(this).parent().parent("form").attr("action","https://www.reservhotel.com/win/owa/ibe5.main");
                $(".booking-v2 form").attr("action","https://www.reservhotel.com/win/owa/ibe5.main");
            //}
        }

    });

    //Guests Selector
    const selector_action = document.getElementsByClassName('selector__custom--action');
    if(selector_action){
        const selector_legth = selector_action.length;
        for(let s = 0; s < selector_legth; s++ ){
            selector_action[s].addEventListener('click', function(){ 
                if(!selector_action[s].classList.contains('inactive')){
                    let $field = selector_action[s].parentElement.getAttribute('data-field'),
                    $min = parseInt(selector_action[s].parentElement.getAttribute('data-min')),
                    $max = parseInt(selector_action[s].parentElement.getAttribute('data-max')),
                    $field_selector = selector_action[s].closest('.selector__custom').parentElement.querySelector(`input[name="${$field}"]`),
                    $current_value = $field_selector.value;
                    let $new_value;
                    if(selector_action[s].classList.contains('increase')){
                        $new_value = parseInt($current_value)+1;
                        if($new_value > $min) {
                            selector_action[s].parentElement.getElementsByClassName('decrease')[0].classList.remove('inactive');
                        }
                        if($new_value == $max) {
                            selector_action[s].classList.add('inactive');
                        }
                    }else{
                        $new_value = parseInt($current_value)-1;

                        if($new_value == $min) {
                            selector_action[s].classList.add('inactive');
                        }
                        if($new_value < $max) {
                            selector_action[s].parentElement.getElementsByClassName('increase')[0].classList.remove('inactive');
                        }
                    } 
                    if($field == 'child') {

                        let current_action = selector_action[s].closest('.selector__custom').parentElement
                        let child_age = current_action.querySelectorAll('.child-age')

                        if(!selector_action[s].classList.contains('increase')) {

                            let elements = [...current_action.querySelectorAll( ".child-age__unit" )]
                            if( $new_value > 0 ){    
                                elements[ elements.length - 1 ].remove()
                            }else{
                                child_age.forEach(function(element) {
                                    element.classList.add('hidden');
                                });
                            }

                        } else {

                            current_action.querySelectorAll('.child-age').forEach(function(element) {
                                element.classList.remove('hidden');
                            });

                            if( $new_value > 1 ){

                                let child_content = document.createElement( "div" )
                                child_content.classList.add( "child-age__unit" )
                                child_content.innerHTML = document.querySelector( ".child-age__unit" ).innerHTML
                                child_age[0].appendChild( child_content )
                                child_content.querySelector( "[for=childrenage2]" ).innerText = "Age Children " + $new_value

                            }else{
                                child_age.forEach(function(element) {
                                    element.classList.remove('hidden');
                                });
                            }

                        }
                    }

                    // const bookingEngine = document.getElementsByName('booking')[0].value;
                    // let age_limit = (booking == 'HoteTec') ? 12 : 17;
                    // document.querySelectorAll('select[name="childages[]"]').forEach(select => {
                    //     select.innerHTML = '';
                    //     for (let i = 1; i <= age_limit; i++) {
                    //         let option = document.createElement('option');
                    //         option.value = i;
                    //         option.textContent = i;
                    //         select.appendChild(option);
                    //     }
                    // });

                    $field_selector.value = $new_value; 
                    selector_action[s].parentElement.getElementsByClassName('selector__custom--total')[0].innerHTML = '0'+$new_value;

                    const totalAdults = selector_action[s].closest('.selector__custom').parentElement.querySelector(`input[name="adult"]`).value;
                    const totalChildren = selector_action[s].closest('.selector__custom').parentElement.querySelector(`input[name="child"]`).value;
                    const totalGuests = parseInt(totalAdults)+parseInt(totalChildren);
                    //document.querySelector(`.fakeguests`).value = '0'+totalGuests; 

                    document.querySelectorAll('.fakeguests').forEach(function(element) {
                        element.value = '0'+totalGuests; 
                    });
                }
            });
        }
    }
  });